import React from 'react';
import classNames from 'classnames';
import EmptyStateImg from 'assets/images/loupe.webp';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';

import './PortfolioDefaulEmpty.styles.scss';
import './PortfolioDefaulEmpty.styles.responsive.scss';

type PortfolioDefaulEmptyProps = {
  className?: string;
  text?: string;
};

const PortfolioDefaulEmpty: React.FC<PortfolioDefaulEmptyProps> = (props) => {
  const { className, children, text } = props;

  const { t } = useTranslation();

  const classes = classNames(
    'portfolio-defaul-empty',
    'white-panel',
    className,
  );

  return (
    <div className={classes}>
      <div className="portfolio-defaul-empty__content">
        <p>{text || t('nothingHereYet')}</p>
        {children}
      </div>

      <ResolveImage
        src={EmptyStateImg}
        asIllustration
        alt="Portfolio is empty."
      />
    </div>
  );
};

export default PortfolioDefaulEmpty;
